import { Box } from '@material-ui/core';
import { PaymentPlanLine } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Font } from '../../../../../../../../shared/components/Font';
import { NemuruDialog } from '../../../../../../../../shared/components/NemuruDialog';
import { Text } from '../../../../../../../../shared/components/Text';
import { PaymentPlanLinePaymentAttempts } from '../../../../../../../PaymentAttempts/PaymentPlanLine/PaymentPlanLinePaymentAttempts';

interface PaymentAttemptsDialogProps {
  opened: boolean;
  setOpened: (boolean) => void;
  paymentPlanLine: PaymentPlanLine;
}

export const PaymentAttemptsDialog = ({ opened, setOpened, paymentPlanLine }: PaymentAttemptsDialogProps) => {
  return (
    <NemuruDialog opened={opened} setOpened={setOpened} dialogProps={{ maxWidth: 'md' }}>
      <Box mb={5}>
        <Font variant={'h3'} color={'title'}>
          <Text tId={'PAYMENT_ATTEMPTS'} />
        </Font>
      </Box>
      <PaymentPlanLinePaymentAttempts paymentPlanLineId={paymentPlanLine.id} />
    </NemuruDialog>
  );
};
